$(document).ready(function () {
  $.getScript('//cdnjs.cloudflare.com/ajax/libs/fancybox/2.1.5/jquery.fancybox.min.js').done(function () {
    quickView()

    window.addEventListener('searchspring.swatchClick', function (scope) {
      const newColor = scope.detail.variant.color

      if (newColor) {
        window.quickViewColor = newColor
      }
    })
  })
})

function quickView() {
  $('.quick-view')
    .off('click')
    .on('click', function () {
      if ($('#quick-view').length == 0) {
        $('body').append('<div id="quick-view"></div>')
      }

      var product_handle = $(this).data('handle')
      $('#quick-view').addClass(product_handle)

      const ssResult = $(this)[0].closest('.ss__result__inner')
      const variant = ssResult.querySelector('.ss__palette__option--active').dataset.variantId
      let url = ''
      if (variant) {
        url = `/products/${product_handle}?view=quickview&variant=${variant}`
      } else {
        url = `/products/${product_handle}?view=quickview`
      }

      $.ajax({
        url: url,
        success: function (response) {
          var htmlData = document.createElement('div')
          htmlData.innerHTML = response
          var productDetail = htmlData.querySelector('[data-product]')
          var quickView = $('#quick-view')
          quickView.html(productDetail)

          // init gallery swiper
          _lspace.swiper.init()

          // set up various quick view PDP functionality
          setupData(url)

          // init yotpo
          var api = new Yotpo.API(yotpo)
          api.refreshWidgets()

          // quick view add to cart
          const atc = $('#quick-view #addtocart')
          atc[0].addEventListener('click', () => {
            $.fancybox.close()
          })

          document.dispatchEvent(new CustomEvent('quickview:loaded'))

          // ensure correct color is selected on quick view
          const navColor = document.querySelector('.nav--color')
          if (navColor) {
            const newColor = navColor.querySelectorAll(`.nav-item[aria-label='${window.quickViewColor ? window.quickViewColor : 'null'}']`)
            if (newColor.length > 0) {
              newColor[0].click()
              window.quickViewColor = null
            }
          }
        }
      })

      $.fancybox({
        href: '#quick-view',
        maxWidth: 1200,
        maxHeight: 770,
        fitToView: true,
        autoScale: true,
        width: '75%',
        height: '85%',
        autoSize: false,
        closeClick: false,
        openEffect: 'none',
        closeEffect: 'none',
        beforeLoad: function () {
          $('.fancybox-wrap').css('overflow', 'hidden !important')
        },
        afterClose: function () {
          $('#quick-view').removeClass().empty()
          document.dispatchEvent(new CustomEvent('quickview:closed'))
        }
      })
    })
}

function setupData(url) {
  var pData = {
    actions: {
      // Utility function to find the first in-stock variant
      findFirstInStockVariant: function() {
        // Check URL parameter first
        const urlParams = new URLSearchParams(url.split('?')[1] || '');
        const urlVariantId = urlParams.get("variant");
        
        if (urlVariantId) {
          // If URL has a variant, check if it's in stock
          if (window.pDataLiquid.config.availability.hasOwnProperty(urlVariantId) && window.pDataLiquid.config.availability[urlVariantId]) {
            return urlVariantId;
          }
        }
        
        // Find first in-stock variant
        for (let i = 0; i < window.pDataLiquid.config.product.variants.length; i++) {
          const variant = window.pDataLiquid.config.product.variants[i];
          if (window.pDataLiquid.config.availability.hasOwnProperty(variant.id) && window.pDataLiquid.config.availability[variant.id]) {
            return variant.id;
          }
        }
        
        // If no in-stock variants found, fall back to first variant
        return window.pDataLiquid.config.product.variants[0].id;
      },
      selectVariant: function (id) {
        // Make the selected variant the value of the form select field
        $('select[name=id]').val(id)

        _lspace.swiper.constrain(id)

        // Check for discounts and apply it to the form discount input
        if (
          window.pDataLiquid.config.variant_discounts.hasOwnProperty(id) &&
          window.pDataLiquid.config.variant_discounts[id].hasOwnProperty('amount')
        ) {
          $('input#discount')
            .attr('name', 'properties[discount_amount]')
            .val(100 - window.pDataLiquid.config.variant_discounts[id].amount)
        } else {
          $('input#discount').attr('name', 'ignore').val('')
        }

        let afterpay = document.querySelector('.afterpay-paragraph')

        for (let vi = 0; vi < window.pDataLiquid.config.product.variants.length; vi++) {
          var v = window.pDataLiquid.config.product.variants[vi]
          if (v.id == id) {
            // Dynamically update og:image meta tag in head
            const metaImg = document.querySelector("meta[property='og:image']")
            const newVariantImg = v.featured_image.src
            // Update the meta tag with new variant img
            metaImg.content = newVariantImg

            $('li[data-option-index="1"][data-value="' + v.option1 + '"]')
              .addClass('active')
              .siblings()
              .removeClass('active')
            $('li[data-option-index="2"][data-value="' + v.option2 + '"]')
              .addClass('active')
              .siblings()
              .removeClass('active')
            $('li[data-option-index="3"][data-value="' + v.option3 + '"]')
              .addClass('active')
              .siblings()
              .removeClass('active')

            if (window.pDataLiquid.config.availability.hasOwnProperty(v.id) && window.pDataLiquid.config.availability[v.id]) {
              if (afterpay) {
                afterpay.style.display = 'block'
              }
              $('#addtocart').removeAttr('disabled').text('Add to Bag')
              $('.BIS_trigger').hide()
            } else {
              $('#addtocart').attr('disabled', 'disabled').text('Out of Stock')
              if (afterpay) {
                afterpay.style.display = 'none'
              }
              $('.BIS_trigger').show()
              $('.BIS_trigger').attr('data-variant-id', id)
            }

            const linkedProduct = document.querySelector('[data-linked-product]')
            if (!linkedProduct) {
              // if price is float, keep 2 digits after decimal; if price is int, remove trailing zeros
              let format_price = (v.price / 100).toFixed(2)
              let firstTwoDigits = (v.price / 100).toFixed(2).slice(-2)
              if (firstTwoDigits === '00') {
                format_price = v.price / 100
              }
              $('#productPrice').text('$ ' + format_price)

              if (v.compare_at_price != v.price) {
                // $('#productPrice p').css('font-weight', 'bold')
                $('#productPrice').html(
                  '<div class="productPrice__container"><p class="productPrice__price">' +
                    $('#productPrice').text() +
                    '</p> ' +
                    '<p class="productPrice__compare">$ ' +
                    v.compare_at_price / 100 +
                    '</p></div>'
                )
              }
            }
          }
        }
      },
      // Selects options and forecasts sold out variants + disables sold out items
      selectOption: function (option, value, selectedOptions, memory) {
        const currentSelection = Object.assign({}, selectedOptions)

        // Add newly clicked selection
        currentSelection[option] = value

        // Adds class .active to selected Option AND removes .active from sibling nodes in same option row
        $('li[data-option-index="' + option + '"][data-value="' + value + '"]')
          .addClass('active')
          .siblings()
          .removeClass('active')

        let updatedMemory = memory

        // Creates memory if it doesn't exist - Memory is used to reduce lookup times by using this as a cache to see, which products are sold out or not.
        if (updatedMemory === undefined) {
          updatedMemory = {}

          // iterate all variants
          window.pDataLiquid.config.product.variants.forEach(function (variant) {
            // Any available options goes in here
            let options = []
            // Check options available
            if (variant.option1) {
              options.push(variant.option1)
            }
            if (variant.option2) {
              options.push(variant.option2)
            }
            if (variant.option3) {
              options.push(variant.option3)
            }

            // Remove spaces from option names such as Midnight Blue => MidnightBlue
            options = options.map(function (option) {
              return option.split(' ').join('')
            })

            // create key to use as memory key e.g. classicWhiteSmall
            const key = options.join('')

            // Set to wheter variant is available or not for quick lookup
            updatedMemory[key] = {
              availability: variant.available,
              id: variant.id // TODO: Does it error here?
            }
          })
        }

        // Grab all option elements - Basically list items with colors, sizes etc.
        const optionElements = document.querySelectorAll('li[data-product-option]')

        // Get current selected options without whitespace
        let selectedOptionOne = ''
        let selectedOptionTwo = ''
        let selectedOptionThree = ''
        let SelectedOptionKey = ''

        // Set the selected options based on which options the user clicked.
        if (currentSelection['1']) {
          selectedOptionOne = currentSelection['1'].split(' ').join('')
        }
        if (currentSelection['2']) {
          selectedOptionTwo = currentSelection['2'].split(' ').join('')
        }
        if (currentSelection['3']) {
          selectedOptionThree = currentSelection['3'].split(' ').join('')
        }

        // Create key in order to access the user's selected variant in memory.
        SelectedOptionKey = selectedOptionOne + (selectedOptionTwo || '') + (selectedOptionThree || '')

        // Iterate over all option dom elements and check against memory
        optionElements.forEach(function (optionEl) {
          // create key to use for memory lookup
          let key = ''
          // The index and value of the dom element (lives in data-option-index and data-value on the element)
          const optionIndex = optionEl.dataset.optionIndex
          const optionValue = optionEl.dataset.value

          // Making sure the current options doesn't contain whitespaces
          const currentOption = optionValue.split(' ').join('')
          // if user clicked an option in index 1
          if (optionIndex === '1') {
            // create key for memory lookup to check for variant availability
            key += currentOption + (selectedOptionTwo || '') + (selectedOptionThree || '')
          } else if (optionIndex === '2') {
            // create key for memory lookup to check for variant availability
            key += selectedOptionOne + currentOption + (selectedOptionThree || '')
          } else if (optionIndex === '3') {
            // create key for memory lookup to check for variant availability
            key += selectedOptionOne + selectedOptionTwo + currentOption
          }

          // Disable or remove disabled class based on variant availability
          let oos_label = "OUT OF STOCK"
          const navLink = optionEl.querySelector('.nav-link');
          if (!updatedMemory[key] || updatedMemory[key].availability === false) {
            if (optionEl.classList.contains('active')) {
              optionEl.classList.remove('disabled');
              if (navLink) {
                navLink.classList.remove('disabled');
                navLink.classList.add('not-disabled');
              }
              // ADA: rm out of stock label
              if(optionEl.ariaLabel && optionEl.ariaLabel.indexOf(oos_label) > -1)
                optionEl.ariaLabel = optionEl.ariaLabel.replace(oos_label, '')
            } else {
              optionEl.classList.add('disabled');
              if (navLink) {
                navLink.classList.add('disabled');
                navLink.classList.remove('not-disabled');
              }
              // ADA: add out of stock label
              if(optionEl.ariaLabel && optionEl.ariaLabel.indexOf(oos_label) === -1){
                optionEl.ariaLabel = oos_label + " " + optionEl.ariaLabel
              }
            }
          } else {
            optionEl.classList.remove('disabled');
            if (navLink) {
              navLink.classList.remove('disabled');
              navLink.classList.add('not-disabled');
            }
            // ADA: rm out of stock label
            if(optionEl.ariaLabel && optionEl.ariaLabel.indexOf(oos_label) > -1)
              optionEl.ariaLabel = optionEl.ariaLabel.replace(oos_label, '')
          }
        })

        // Variant id of selected variant
        const selectedVariantId = updatedMemory[SelectedOptionKey] && updatedMemory[SelectedOptionKey].id

        if (selectedVariantId) {
          pData.actions.selectVariant(selectedVariantId)
        } else {
          // DISABLE ADD TO CART IF THE SELECTED VARIANT DOESNT EXIST
          $('#addtocart').attr('disabled', 'disabled').text('Unavailable')
        }

        setTimeout(function () {
          $(document).trigger('product:OptionSelected')
        }, 200)

        // Returns the user's selected options + current memory so we can pass this in on the next function call and save time on lookup/iteration
        return {
          selectedOptions: currentSelection,
          memory: updatedMemory
        }
      },
      showAvailableColors: function () {
        var selectedCoverage = $.trim($('div[data-option="Coverage"] .nav-item.active span').text())
        if (selectedCoverage) {
          var coverageColors = []
          for (variant of window.pDataLiquid.config.product.variants) {
            if (selectedCoverage === variant.option1) {
              coverageColors.push(variant.option2.toLowerCase())
            }
          }
          //remove duplicates in array
          var availableColors = [...new Set(coverageColors)]
          //if a color is not available for the coverage clicked on, add a strikethrough
          $('li[data-option-index="2"]').each(function (index, color) {
            var currentColor = $.trim($(color).attr('data-value').toLowerCase())
            if (!availableColors.includes(currentColor)) {
              $(color).addClass('not-available')
            } else {
              $(color).removeClass('not-available')
            }
          })
        }
      }
    },
    init: function () {
      if (window.pDataLiquid.config.child.variants)
        window.pDataLiquid.config.product.variants = window.pDataLiquid.config.product.variants.concat(window.pDataLiquid.config.child.variants)

      // Select the first in-stock variant or URL variant if available
      const selectedVariantId = pData.actions.findFirstInStockVariant();
      pData.actions.selectVariant(selectedVariantId);
      $('body').on('click', 'div[data-option="Coverage"] .nav-item.active', pData.actions.showAvailableColors)
      pData.actions.showAvailableColors()

      // add event listeners
      function addOptionClickListeners() {
        const clickableOptions = document.querySelectorAll('li[data-product-option]')
        // State will change based on clicked options

        // Select the first in-stock variant or URL variant if available
        const selectedVariantId = pData.actions.findFirstInStockVariant();
        let selectedVariant

        window.pDataLiquid.config.product.variants.forEach(function (variant) {
          if (variant.id == selectedVariantId) {
            selectedVariant = variant
          }
        })

        // find available options from selectedVariant
        let selectedOptions = {}
        let colorSelect

        if (selectedVariant.option1) {
          selectedOptions[1] = selectedVariant.option1
          colorSelect = selectedVariant.option1
        }
        if (selectedVariant.option2) {
          selectedOptions[2] = selectedVariant.option2
        }
        if (selectedVariant.option3) {
          selectedOptions[3] = selectedVariant.option3
          colorSelect = selectedVariant.option2
        }

        // display color based on variant
        let colorDisplay = document.getElementById('product-box__option-color')

        if (colorDisplay) {
          colorDisplay.innerText = colorSelect
        }

        let memory

        const initialOptionRow = '1'
        const initialOptionValue = selectedOptions['1']

        // Initialize what is sold out on first run and create memory store
        const initialState = pData.actions.selectOption(initialOptionRow, initialOptionValue, selectedOptions, memory)

        // Update selectedOptions and memory so it's ready for when user clicks another option
        selectedOptions = initialState.selectedOptions
        memory = initialState.memory

        let colorList = document.querySelectorAll('li[data-colorcheck="color"]')
        colorList = [...colorList].map((val) => val.dataset.colorvalue)

        for (let i = 0; i < colorList.length; i++) {
          let color = colorList[i].replace(/-/g, '')
          let soldOut = true
          for (option in memory) {
            if (option.split('-').join('').toLowerCase().includes(color)) {
              if (memory[option].availability == true) {
                soldOut = false
              }
            }
          }
          if (soldOut) {
            let soldOutColor = document.querySelector(`li[data-colorvalue=${colorList[i]}]`)
            soldOutColor.classList.add('soldOut')
          }
        }

        // Add event listeners to all options
        clickableOptions.forEach(function (option) {
          option.addEventListener('click', function (e) {
            const clickedOption = e.currentTarget
            const optionRow = clickedOption.dataset.optionIndex
            const optionValue = clickedOption.dataset.value

            const updatedState = pData.actions.selectOption(optionRow, optionValue, selectedOptions, memory)
            const newMemory = updatedState.memory
            const newSelectedOptions = updatedState.selectedOptions
            const detailsButton = document.querySelector('[data-details-link]')
            const newSelectedOptionsKey = Object.values(newSelectedOptions).join('').replace(/\s/g, '')
            const selectedVariantId = newMemory[newSelectedOptionsKey].id

            // update state
            selectedOptions = newSelectedOptions
            memory = newMemory

            const colorCheck = clickedOption.dataset.colorcheck

            //update color display
            if (colorCheck === 'color') {
              colorDisplay.innerText = optionValue
              //update details button url on color change
              let variantURL = new URL(detailsButton.href)
              variantURL.searchParams.set('variant', selectedVariantId)
              detailsButton.href = variantURL.href
            }
          })
        })
      }

      // Initialize click listeners
      addOptionClickListeners()
    }
  }
  $(pData.init)
}
